module.exports = __webpack_public_path__ + "img/lg_ring_r_c_1_null@2x.0ae2a691.png";